import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";

export default function StaffAugmentationService() {
  return (
    <div className="Staff-Augmentation-Service pt-[160px] sm:pt-0">
      <Helmet>
        <title>Top Staff Augmentation Services | Mean3</title>
        <meta
        name="description"
        content="Mean3 offers reliable staff augmentation services. Scale your team with skilled professionals and achieve your business goals. Contact us now!"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
    </div>
  );
}
